import React, { FC, useState } from 'react';
import { Box, Drawer, IconButton, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedYear } from '../../features/yearSlice';
import { ModeSwitch } from './ModeSwitch';

interface Props {
    onToggleDarkTheme: () => void;
    toggleDarkMode: boolean;
}

export const MobileMenu: FC<Props> = ({ onToggleDarkTheme, toggleDarkMode }) => {
    const [open, setOpen] = useState(false);
    const selectedYear: number = useSelector((state: any) => state.years.selectedYear);
    const years: number[] = useSelector((state: any) => state.years.years);
    const dispatch = useDispatch();

    const toggleDrawer = (state: boolean) => () => {
        setOpen(state);
    };

    const selectYearAndCloseMenu = (year: number): void => {
        setOpen(false);
        dispatch(setSelectedYear(year));
    };

    return (
        <Box className="menu">
            {/* Menu button */}
            <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                <MenuIcon />
            </IconButton>

            {/* Drawer */}
            <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                    sx={{
                        width: 250,
                        backgroundColor: (theme) => (theme.palette.mode === 'light' ? 'rgba(203,203,203)' : undefined),
                    }}
                    role="presentation"
                >
                    {/* Close button inside drawer */}
                    <IconButton edge="end" onClick={toggleDrawer(false)}>
                        <CloseIcon />
                    </IconButton>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '95.8vh',
                        }}
                    >
                        <List className="list-items">
                            {years.map((year: number) => (
                                <ListItem
                                    key={year}
                                    component="button"
                                    onClick={() => selectYearAndCloseMenu(year)}
                                    style={{ cursor: 'pointer', border: 'none', margin: '5px', width: '95%' }}
                                    className={year === selectedYear ? 'active' : ''}
                                >
                                    <ListItemText primary={year} />
                                </ListItem>
                            ))}
                        </List>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                paddingBottom: '10px',
                            }}
                        >
                            <ModeSwitch onToggleDarkMode={onToggleDarkTheme} toggleDarkMode={toggleDarkMode} />
                        </Box>
                    </Box>
                </Box>
            </Drawer>
        </Box>
    );
};
